/*
 * El trío va siempre pegado al borde derecho de la cabecera, sin encogerse:
 * es el ancla de la fila y su posición no debe bailar según lo largo que sea
 * el título de cada pantalla.
 */
.grupo {
  flex-shrink: 0;
  margin-left: auto;
}
